<template>
  <div class="lc-editor-stages-controls">
    <i-button
      type="default"
      size="small"
      @click="exportLawCase"
      icon="md-cloud-download"
      v-if="lawCase.id"
    >
      Экспорт судебного дела
    </i-button>
    <i-button type="primary" size="small" @click="addLawCaseStage">
      Добавить событие
    </i-button>
  </div>
</template>

<script>
import { mainUrl } from '@/config/urls'
import { downloadFile } from '@/utils'

export default {
  props: ['law-case'],
  data () {
    return {
      token: this.$store.state.auth.token
    }
  },
  methods: {
    addLawCaseStage () {
      this.$emit('add-law-case-stage')
    },
    exportLawCase () {
      const url = `${mainUrl}/api/page/law_case/${this.lawCase.id}?format=excel&access_token=${this.token}`
      downloadFile(url)
    }
  }
}
</script>

<style lang="less">
.lc-editor-stages-controls {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  .ivu-btn:last-child {
    margin-left: auto;
  }
}
</style>
